import type { Branding } from "@/src/branding/branding-context.ts";

export const defaultBranding = (apiUrl?: string): Branding => ({
    cssVariables: {
        "--primary-color": "#1B242D",
        "--light-primary-color": "#1A6ABA",
        "--secondary-color": "#00D0FF",
    },
    envVariables: {
        VITE_IOT_ADMIN_API_SERVER_URL:
            apiUrl ?? "https://ror1.staging.nazaries.cloud",
        VITE_IOT_CONTACT_URL: "https://www.nazaries.com/es/contacto",
        VITE_IOT_BACKGROUND_IMG: "login-background.png",
        VITE_IOT_LOGO_IMG: "branding/default/logo.png",
        VITE_IOT_NEGATIVE_LOGO_IMG: "branding/default/logo-negative.png",
        VITE_IOT_LARGE_LOGO_IMG: "branding/default/logo-large.png",
        VITE_IOT_COOKIES_URL: "https://nazaries.com/politica-de-cookies",
        VITE_IOT_LEGAL_URL: "https://www.nazaries.com/en/legal-notice",
        VITE_IOT_PRIVACY_URL: "https://nazaries.com/politica-de-privacidad",
        VITE_IOT_ABOUT_URL: "https://www.nazaries.com/en/about-us",
        VITE_IOT_APP_TITLE: "Nazaries",
        VITE_IOT_FAVICON: "branding/default/favicon.png",
    },
});
